/**
 * ntc-barra-veicolo.js — la barra «TROVA I RICAMBI», sempre in alto.
 *
 * ⭐ Rifa' su Shopify le cinque tendine di ntc-italia.it: marca, modello, versione, ANNO e
 * TIPO DI PEZZO. L'auto scelta resta mentre si naviga; la × azzera tutto.
 *
 * ⚠️ L'ANNO non filtra i prodotti: restringe le VERSIONI, come su Woo. Un ricambio non ha
 * un anno suo — ce l'ha l'auto su cui si monta. Chi sceglie «2004» deve vedere le versioni
 * in produzione nel 2004, e cercare quella.
 * ⚠️ Una versione SENZA anni non sparisce mai col filtro: il catalogo non ha gli anni
 * dappertutto, e nascondere quelle voci farebbe sembrare che il ricambio non esista.
 *
 * ⚠️ L'auto scelta sta nel BROWSER del cliente (localStorage), non sul server: e' una
 * comodita' sua, non un dato nostro, e non deve seguirlo altrove ne' finire in un profilo.
 * Se il browser blocca la memoria (finestra anonima, impostazioni), la barra funziona lo
 * stesso: semplicemente non ricorda. Per questo ogni lettura e scrittura sta in un
 * try/catch invece di fidarsi.
 */
( function () {
  'use strict';

  var CHIAVE = 'ntc_auto';

  function leggi() {
    try {
      var s = window.localStorage.getItem( CHIAVE );
      return s ? JSON.parse( s ) : null;
    } catch ( e ) { return null; }
  }
  function salva( v ) {
    try { window.localStorage.setItem( CHIAVE, JSON.stringify( v ) ); } catch ( e ) {}
  }
  function scorda() {
    try { window.localStorage.removeItem( CHIAVE ); } catch ( e ) {}
  }

  /**
   * ⛔ Shopify SPEGNE i filtri delle collezioni con piu' di 5.000 prodotti (12/09/2026: BMW ne ha 5.620 in
   * vetrina, e `/collections/bmw?filter.p.m.custom.versione_auto=BMW Serie 4 F33` mostrava sempre tutto, senza
   * colonna dei filtri). Quanti prodotti ha la collezione lo dice il negozio (`/collections/<marca>.json`); si
   * ricorda per la sessione.
   */
  var TETTO_FILTRI = 5000;
  function grande( handle ) {
    var chiave = 'ntc_grande_' + handle;
    try {
      var s = window.sessionStorage.getItem( chiave );
      if ( s === '1' || s === '0' ) { return Promise.resolve( s === '1' ); }
    } catch ( e ) {}
    return fetch( '/collections/' + encodeURIComponent( handle ) + '.json', { credentials: 'omit' } )
      .then( function ( r ) { return r.ok ? r.json() : null; } )
      .then( function ( d ) {
        var si = !! ( d && d.collection && d.collection.products_count > TETTO_FILTRI );
        try { window.sessionStorage.setItem( chiave, si ? '1' : '0' ); } catch ( e ) {}
        return si;
      } )
      .catch( function () { return false; } );
  }

  /**
   * ⭐ [ntc-collezioni-modello] 12/09/2026: sulle marche oltre 5.000 prodotti (BMW) ogni MODELLO ha la sua collezione
   * automatica («tag uguale a BMW Serie 3», handle bmw-serie-3) con gli stessi pezzi del conto della barra e i filtri veri.
   * La ricerca si fermava a 1.000 risultati e cercava per tag (1.355 pezzi contro 1.833): «nel menu dice 1833, sotto 1000».
   * Se la collezione del modello non c'è (o supera anche lei i 5.000) si resta sulla ricerca. Si ricorda per la sessione.
   */
  function slug( t ) {
    return String( t || '' ).normalize( 'NFKD' ).replace( /[^ -~]/g, '' ).toLowerCase()
      .replace( /[^a-z0-9]+/g, '-' ).replace( /^-+|-+$/g, '' );
  }
  function collezioneModello( tag ) {
    var h = slug( tag );
    var chiave = 'ntc_colmod_' + h;
    try {
      var s = window.sessionStorage.getItem( chiave );
      if ( s === '1' ) { return Promise.resolve( h ); }
      if ( s === '0' ) { return Promise.resolve( '' ); }
    } catch ( e ) {}
    return fetch( '/collections/' + encodeURIComponent( h ) + '.json', { credentials: 'omit' } )
      .then( function ( r ) { return r.ok ? r.json() : null; } )
      .then( function ( d ) {
        var si = !! ( d && d.collection && d.collection.products_count > 0 && d.collection.products_count <= TETTO_FILTRI );
        try { window.sessionStorage.setItem( chiave, si ? '1' : '0' ); } catch ( e ) {}
        return si ? h : '';
      } )
      .catch( function () { return ''; } );
  }
  function indirizzoModello( hm, ver, tipo ) {
    var q = [];
    if ( ver ) { q.push( 'filter.p.m.custom.versione_auto=' + encodeURIComponent( ver ) ); }
    if ( tipo ) { q.push( 'filter.p.product_type=' + encodeURIComponent( tipo ) ); }
    return '/collections/' + hm + ( q.length ? '?' + q.join( '&' ) : '' );
  }
  /**
   * [ntc-collezioni-modello] La ricerca ESATTA «tag:"BMW Serie 3"» (link vecchi, Google, tasto indietro, il ripiego) → la
   * collezione del modello, con la stessa versione e lo stesso tipo. Le ricerche dei consigli («(tag:A OR tag:B)») no.
   */
  function aCollezione( albero ) {
    if ( window.location.pathname.replace( /\/$/, '' ).split( '/' ).pop() !== 'search' ) { return; }
    var p = new URLSearchParams( window.location.search );
    var m = ( p.get( 'q' ) || '' ).match( /^\s*tag:"([^"]+)"(?:\s+AND\s+product_type:"([^"]+)")?\s*$/ );
    if ( ! m ) { return; }
    var marca = null, mm = null;
    albero.some( function ( x ) {
      mm = ( x.m || [] ).filter( function ( y ) { return y.t === m[ 1 ]; } )[ 0 ] || null;
      marca = mm ? x : null;
      return !! mm;
    } );
    if ( ! mm || ! marca.h ) { return; }
    var ver = p.get( 'filter.p.m.custom.versione_auto' ) || p.get( 'ntc_ripiego' ) || '';
    var tipo = m[ 2 ] || p.get( 'filter.p.product_type' ) || '';
    grande( marca.h ).then( function ( g ) { return g ? collezioneModello( mm.t ) : ''; } ).then( function ( hm ) {
      if ( hm ) { window.location.replace( indirizzoModello( hm, ver, tipo ) ); }
    } );
  }

  /**
   * La ricerca che filtra davvero sulle marche grandi: il tag del MODELLO (o della marca) e il tipo nella domanda,
   * la versione come filtro del campo `versione_auto` — i nomi delle versioni non sono tag.
   * Misurato: `tag:"BMW Serie 4"` 296 pezzi, con la versione F33 91. ⚠️ La ricerca si ferma a 1.000 risultati.
   */
  function ricercaGrande( tagBase, tipo, versioneScelta ) {
    var s = 'tag:"' + tagBase + '"';
    if ( tipo ) { s += ' AND product_type:"' + tipo + '"'; }
    return '/search?q=' + encodeURIComponent( s ) + '&type=product&options%5Bprefix%5D=last' +
      ( versioneScelta ? '&filter.p.m.custom.versione_auto=' + encodeURIComponent( versioneScelta ) : '' );
  }

  /**
   * Dove mandare il cliente.
   *
   * ⭐ SE C'E' SOLO LA MARCA si va alla sua COLLEZIONE (`/collections/bmw`), non alla
   * ricerca: la collezione ha i filtri veri, l'ordinamento, le pagine e un testo che Google
   * legge. Il filtro per tipo di pezzo li' funziona davvero — misurato:
   * `/collections/bmw?filter.p.product_type=Griglie` → 431 prodotti su 2.331.
   * ⚠️ Per modello e versione una collezione non c'e', e li' si usa la ricerca per tag:
   * e' l'unica cosa che filtra su questo negozio (il filtro `filter.p.tag` e' spento).
   */
  function indirizzo( tag, tipo, handle, livello ) {
    if ( handle ) {
      var q = [];
      // ⚠️ Il filtro si applica al livello scelto: la versione se c'e', altrimenti il
      //    modello. Sulla sola marca basta la collezione, che gia' contiene solo quella.
      if ( livello === 'versione' ) {
        q.push( 'filter.p.m.custom.versione_auto=' + encodeURIComponent( tag ) );
      } else if ( livello === 'modello' ) {
        q.push( 'filter.p.m.custom.modello_auto=' + encodeURIComponent( tag ) );
      }
      if ( tipo ) { q.push( 'filter.p.product_type=' + encodeURIComponent( tipo ) ); }
      return '/collections/' + handle + ( q.length ? '?' + q.join( '&' ) : '' );
    }
    // ⚠️ Ripiego per una marca senza collezione: la ricerca per tag filtra lo stesso,
    //    ma senza barra dei filtri ne' ordinamento.
    var s = 'tag:"' + tag + '"';
    if ( tipo ) { s += ' AND product_type:"' + tipo + '"'; }
    return '/search?q=' + encodeURIComponent( s ) +
      '&type=product&options%5Bprefix%5D=last';
  }

  /**
   * Che auto sta guardando il cliente, secondo l'INDIRIZZO della pagina.
   *
   * ⛔ Prima la barra si riempiva solo dalla memoria del browser. Chi arrivava su
   * `/collections/alfa-romeo?...modello_auto=Alfa Romeo Giulietta` — da Google, da un link
   * condiviso, dal tasto indietro, o dal selettore della home che non salvava niente —
   * vedeva la pagina filtrata su Giulietta e le tendine VUOTE. La pagina dice gia' che auto
   * e': basta leggerla.
   *
   * ⚠️ L'indirizzo VINCE sulla memoria: se sto guardando le Giulietta, la barra deve dire
   * Giulietta anche se ieri avevo cercato una BMW.
   */
  function dallIndirizzo( albero ) {
    var p = new URLSearchParams( window.location.search );
    var tag = p.get( 'filter.p.m.custom.versione_auto' ) ||
              p.get( 'ntc_ripiego' ) ||
              p.get( 'filter.p.m.custom.modello_auto' ) ||
              p.get( 'filter.p.m.custom.marca_auto' ) || '';

    // la collezione di una marca: /collections/bmw
    if ( ! tag ) {
      var c = window.location.pathname.match( /\/collections\/([^\/?#]+)/ );
      if ( c ) {
        var marca = albero.filter( function ( x ) { return x.h === c[ 1 ]; } )[ 0 ];
        if ( marca ) { tag = marca.t; }
        // [ntc-collezioni-modello] la collezione di un modello: /collections/bmw-serie-3
        if ( ! marca ) {
          albero.some( function ( x ) {
            var mm = ( x.m || [] ).filter( function ( y ) { return slug( y.t ) === c[ 1 ]; } )[ 0 ];
            if ( mm ) { tag = mm.t; }
            return !! mm;
          } );
        }
      }
    }
    // la ricerca per tag, che resta il ripiego per le marche senza collezione
    if ( ! tag ) {
      var s = ( p.get( 'q' ) || '' ).match( /tag:"([^"]+)"/ );
      if ( s ) { tag = s[ 1 ]; }
    }
    return tag;
  }

  function tipoDallIndirizzo() {
    var p = new URLSearchParams( window.location.search );
    // ⚠️ sulla ricerca il tipo sta DENTRO la domanda: tag:"…" AND product_type:"Griglie"
    var s = ( p.get( 'q' ) || '' ).match( /product_type:"([^"]+)"/ );
    return p.get( 'filter.p.product_type' ) || ( s ? s[ 1 ] : '' );
  }

  /**
   * ⛔ [ntc-ripiego-versione] 12/09/2026: la RICERCA di Shopify aggiorna i valori dei campi con ORE di ritardo (le
   * collezioni in pochi minuti). Dopo il cambio dei nomi delle versioni «BMW › Serie 4 › F33 (Cabrio)» — BMW passa dalla
   * ricerca — dava ZERO risultati. Ricerca con versione e 0 risultati → la stessa ricerca senza la versione (tutti i
   * pezzi del modello); la barra resta sulla versione scelta grazie a `ntc_ripiego`.
   */
  function ripiega() {
    if ( window.location.pathname.replace( /\/$/, '' ).split( '/' ).pop() !== 'search' ) { return false; }
    var p = new URLSearchParams( window.location.search );
    var ver = p.get( 'filter.p.m.custom.versione_auto' );
    if ( ! ver || p.get( 'ntc_ripiego' ) ) { return false; }
    // ⚠️ la ricerca vuota NON scrive «0 risultati»: c'è il blocco «Nessun risultato trovato» del tema e la griglia è vuota
    var griglia = document.getElementById( 'product-grid' );
    var vuota = !! document.querySelector( '.search-empty-state, .template-search-empty' ) ||
      ( !! griglia && griglia.children.length === 0 && ! document.getElementById( 'ProductCount' ) );
    if ( ! vuota ) { return false; }
    p.delete( 'filter.p.m.custom.versione_auto' );
    p.set( 'ntc_ripiego', ver );
    window.location.replace( window.location.pathname + '?' + p.toString() );
    return true;
  }

  /**
   * ⛔ Una collezione MARCA coi filtri nell'indirizzo ma senza filtri veri nella pagina: Shopify li ha spenti (oltre
   * 5.000 prodotti) e la pagina mostra TUTTO. Succede da link vecchi, da Google, dal tasto indietro: si passa alla
   * ricerca equivalente, che filtra davvero.
   * ⚠️ Il modulo `facet-filters-form` c'e' anche li' (e' l'ordinamento): contano i gruppi `.js-filter` e i campi `filter.*`.
   */
  function rimanda( albero ) {
    var c = window.location.pathname.match( /\/collections\/([^\/?#]+)\/?$/ );
    if ( ! c ) { return false; }
    var p = new URLSearchParams( window.location.search );
    var ver = p.get( 'filter.p.m.custom.versione_auto' ) || '';
    var mod = p.get( 'filter.p.m.custom.modello_auto' ) || '';
    var tipo = p.get( 'filter.p.product_type' ) || '';
    if ( ! ver && ! mod && ! tipo ) { return false; }
    if ( document.querySelector( '.js-filter, input[name^="filter."]' ) ) { return false; }
    var marca = albero.filter( function ( x ) { return x.h === c[ 1 ]; } )[ 0 ];
    if ( ! marca ) { return false; }
    if ( ver && ! mod ) {
      var mm = ( marca.m || [] ).filter( function ( x ) { return ver.indexOf( x.t + ' ' ) === 0; } )
        .sort( function ( a, b ) { return b.t.length - a.t.length; } )[ 0 ];   // [ntc-nome-intero] il più lungo
      mod = mm ? mm.t : '';
    }
    if ( ! mod ) { window.location.replace( ricercaGrande( marca.t, tipo, ver ) ); return true; }
    // [ntc-collezioni-modello] c'è il modello: la sua collezione se esiste, altrimenti la ricerca di prima
    collezioneModello( mod ).then( function ( hm ) {
      window.location.replace( hm ? indirizzoModello( hm, ver, tipo ) : ricercaGrande( mod, tipo, ver ) );
    } );
    return true;
  }

  /** La voce copre quell'anno? Chi non ha anni copre sempre. */
  function copre( v, a ) {
    if ( ! a ) { return true; }
    if ( ! v.da && ! v.a ) { return true; }
    if ( v.da && a < v.da ) { return false; }
    if ( v.a && a > v.a ) { return false; }
    return true;
  }

  function avvia( radice ) {
    if ( radice.dataset.ntcPronto === '1' ) { return; }
    radice.dataset.ntcPronto = '1';

    var albero = [];
    var tipi = [];
    var q = function ( n ) { return radice.querySelector( '[data-ntc="' + n + '"]' ); };
    var marca = q( 'marca' ), modello = q( 'modello' ), versione = q( 'versione' );
    var anno = q( 'anno' ), tipo = q( 'tipo' );
    var cerca = q( 'cerca' ), azzera = q( 'azzera' );
    var apri = q( 'apri' ), apriTesto = q( 'apri-testo' ), modulo = q( 'modulo' );
    if ( ! marca || ! modulo ) { return; }

    function vuoto( sel ) { return sel.getAttribute( 'data-vuoto' ) || ''; }

    function svuota( sel ) {
      if ( ! sel ) { return; }
      sel.innerHTML = '<option value="">' + vuoto( sel ) + '</option>';
      sel.disabled = true;
    }

    function riempi( sel, voci, valore ) {
      if ( ! sel ) { return; }
      sel.innerHTML = '<option value="">' + vuoto( sel ) + '</option>';
      voci.forEach( function ( v ) {
        var o = document.createElement( 'option' );
        o.value = v.t;
        o.textContent = v.c ? v.n + ' (' + v.c + ')' : v.n;
        sel.appendChild( o );
      } );
      sel.disabled = voci.length === 0;
      if ( valore ) { sel.value = valore; }
    }

    function trova( elenco, tag ) {
      for ( var i = 0; i < elenco.length; i++ ) {
        if ( elenco[ i ].t === tag ) { return elenco[ i ]; }
      }
      return null;
    }

    function laMarca() { return trova( albero, marca.value ); }
    function ilModello() {
      var m = laMarca();
      return m ? trova( m.m, modello.value ) : null;
    }

    /** Gli anni da mettere in tendina: quelli coperti da cio' che si e' gia' scelto. */
    function anniPossibili() {
      var da = null, a = null;
      var fonte = [];
      var mm = ilModello();
      var m = laMarca();
      if ( mm ) { fonte = [ mm ].concat( mm.v || [] ); }
      else if ( m ) { fonte = [ m ].concat( m.m || [] ); }
      else { fonte = albero; }
      fonte.forEach( function ( v ) {
        if ( v.da && ( da === null || v.da < da ) ) { da = v.da; }
        if ( v.a && ( a === null || v.a > a ) ) { a = v.a; }
      } );
      if ( da === null || a === null ) { return []; }
      var fuori = [];
      for ( var y = a; y >= da; y-- ) { fuori.push( { t: String( y ), n: String( y ) } ); }
      return fuori;
    }

    function aggiornaAnni() {
      if ( ! anno ) { return; }
      var scelto = anno.value;
      var voci = anniPossibili();
      riempi( anno, voci, voci.some( function ( v ) { return v.t === scelto; } ) ? scelto : '' );
      anno.disabled = voci.length === 0;
    }

    function aggiornaModelli() {
      var m = laMarca();
      var a = anno ? parseInt( anno.value, 10 ) : 0;
      var voci = m ? ( m.m || [] ).filter( function ( x ) { return copre( x, a ); } ) : [];
      var tenere = modello.value;
      riempi( modello, voci, voci.some( function ( v ) { return v.t === tenere; } ) ? tenere : '' );
    }

    function aggiornaVersioni() {
      var mm = ilModello();
      var a = anno ? parseInt( anno.value, 10 ) : 0;
      var voci = mm ? ( mm.v || [] ).filter( function ( x ) { return copre( x, a ); } ) : [];
      var tenere = versione.value;
      riempi( versione, voci, voci.some( function ( v ) { return v.t === tenere; } ) ? tenere : '' );
    }

    function nomeScelto() {
      return [ marca, modello, versione ].map( function ( s ) {
        return s && s.value ? s.options[ s.selectedIndex ].textContent
          .replace( /\s*\(\d+\)\s*$/, '' ) : '';
      } ).filter( Boolean ).join( ' ' );
    }

    function aggiorna() {
      var qualcosa = !! ( marca.value || ( tipo && tipo.value ) );
      cerca.disabled = ! qualcosa;
      if ( azzera ) {
        azzera.hidden = ! ( marca.value || ( anno && anno.value ) || ( tipo && tipo.value ) );
      }
      if ( apriTesto && marca.value ) { apriTesto.textContent = nomeScelto(); }
    }

    function vai() {
      var tag = versione.value || modello.value || marca.value;
      var t = tipo ? tipo.value : '';
      if ( ! tag && ! t ) { return; }
      if ( tag ) { salva( { tag: tag, nome: nomeScelto() } ); }
      if ( ! tag ) {
        // ⚠️ Senza auto ma con un tipo di pezzo si cerca lo stesso: e' legittimo.
        window.location.href = '/search?q=' +
          encodeURIComponent( 'product_type:"' + t + '"' ) +
          '&type=product&options%5Bprefix%5D=last';
        return;
      }
      // ⭐ Si va SEMPRE alla collezione della marca, restringendo col filtro giusto: la
      //    pagina categoria ha la barra dei filtri, l'ordinamento, le pagine e un testo
      //    che Google legge — la ricerca non ha niente di tutto questo.
      var m = laMarca();
      var livello = versione.value ? 'versione' : ( modello.value ? 'modello' : 'marca' );
      // ⛔ Oltre 5.000 prodotti Shopify spegne i filtri della collezione: li' modello, versione e tipo passano
      //    dalla ricerca. La sola marca resta la sua collezione (banner, logo, testo per Google).
      if ( m && m.h && ( livello !== 'marca' || t ) ) {
        cerca.disabled = true;
        grande( m.h ).then( function ( g ) {
          if ( ! g ) { window.location.href = indirizzo( tag, t, m.h, livello ); return; }
          if ( ! modello.value ) { window.location.href = ricercaGrande( marca.value, t, '' ); return; }
          // [ntc-collezioni-modello] marca grande + modello → la collezione del modello (filtri veri, numeri della barra)
          collezioneModello( modello.value ).then( function ( hm ) {
            window.location.href = hm
              ? indirizzoModello( hm, versione.value, t )
              : ricercaGrande( modello.value, t, versione.value );
          } );
        } );
        return;
      }
      window.location.href = indirizzo( tag, t, m ? m.h : '', livello );
    }

    marca.addEventListener( 'change', function () {
      svuota( versione );
      aggiornaModelli();
      aggiornaAnni();
      aggiorna();
    } );
    modello.addEventListener( 'change', function () {
      aggiornaVersioni();
      aggiornaAnni();
      aggiorna();
    } );
    versione.addEventListener( 'change', aggiorna );
    if ( anno ) {
      anno.addEventListener( 'change', function () {
        aggiornaModelli();
        aggiornaVersioni();
        aggiorna();
      } );
    }
    if ( tipo ) { tipo.addEventListener( 'change', aggiorna ); }
    cerca.addEventListener( 'click', vai );

    if ( azzera ) {
      azzera.addEventListener( 'click', function () {
        scorda();
        marca.value = '';
        svuota( modello );
        svuota( versione );
        if ( anno ) { anno.value = ''; }
        if ( tipo ) { tipo.value = ''; }
        aggiornaAnni();
        if ( apriTesto ) {
          apriTesto.textContent = apri.getAttribute( 'data-testo' ) || apriTesto.textContent;
        }
        aggiorna();
      } );
    }
    if ( apri ) {
      apri.setAttribute( 'data-testo', apriTesto ? apriTesto.textContent : '' );
      apri.addEventListener( 'click', function () {
        var acceso = modulo.getAttribute( 'data-aperto' ) !== '1';
        if ( acceso ) { modulo.setAttribute( 'data-aperto', '1' ); }
        else { modulo.removeAttribute( 'data-aperto' ); }
        apri.setAttribute( 'aria-expanded', acceso ? 'true' : 'false' );
      } );
    }

    svuota( modello );
    svuota( versione );

    fetch( radice.getAttribute( 'data-albero' ), { credentials: 'omit' } )
      .then( function ( r ) { return r.json(); } )
      .then( function ( d ) {
        albero = d || [];
        if ( rimanda( albero ) || ripiega() ) { return; }
        aCollezione( albero );
        riempi( marca, albero );
        aggiornaAnni();
        // ⚠️ Prima l'INDIRIZZO della pagina, poi la memoria del browser: chi sta guardando
        //    le Giulietta deve vedere «Giulietta» nelle tendine, non la BMW di ieri.
        var daUrl = dallIndirizzo( albero );
        var v = daUrl ? { tag: daUrl, nome: daUrl } : leggi();

        if ( v && v.tag ) {
          // ⛔ [ntc-nome-intero] «Mercedes GL» è l'inizio anche di «Mercedes GLE…»: vale il nome INTERO (seguito da uno
          //    spazio, o il valore tutto) e fra più candidati il più lungo («Range Rover Sport» prima di «Range Rover»)
          var intero = function ( x ) { return v.tag === x.t || v.tag.indexOf( x.t + ' ' ) === 0; };
          var lungo = function ( a, b ) { return b.t.length - a.t.length; };
          var m = albero.filter( intero ).sort( lungo )[ 0 ];
          if ( m ) {
            marca.value = m.t;
            aggiornaModelli();
            var mm = ( m.m || [] ).filter( intero ).sort( lungo )[ 0 ];
            if ( mm ) {
              modello.value = mm.t;
              aggiornaVersioni();
              if ( v.tag !== mm.t ) { versione.value = v.tag; }
            }
            aggiornaAnni();
            // ⚠️ Si rimette in memoria col nome LEGGIBILE («Alfa Romeo Giulietta», non il
            //    tag grezzo), cosi' l'auto resta anche uscendo dalle pagine filtrate.
            if ( daUrl ) { salva( { tag: v.tag, nome: nomeScelto() || v.tag } ); }
          }
        }
        aggiorna();
      } )
      .catch( function () { /* la barra resta, le tendine no: meglio che sparire */ } );

    if ( tipo ) {
      fetch( radice.getAttribute( 'data-tipi' ), { credentials: 'omit' } )
        .then( function ( r ) { return r.json(); } )
        .then( function ( d ) {
          tipi = ( d || [] ).map( function ( x ) { return { t: x.t, n: x.t, c: x.c }; } );
          // ⚠️ Anche il tipo di pezzo si legge dall'indirizzo: se la pagina e' filtrata su
          //    «Griglie», la tendina lo deve dire.
          riempi( tipo, tipi, tipoDallIndirizzo() );
          aggiorna();
        } )
        .catch( function () {} );
    }
  }

  function tutte() {
    document.querySelectorAll( '[data-ntc-barra-veicolo]' ).forEach( avvia );
  }
  if ( document.readyState === 'loading' ) {
    document.addEventListener( 'DOMContentLoaded', tutte );
  } else { tutte(); }
  document.addEventListener( 'shopify:section:load', tutte );
}() );
